// Canonical age content rating values used for `allowedContentRestrictions`.
// Ratings are cumulative (a ceiling): allowing a value implies everything below it.
export const defaultContentRatingList = [6, 9, 12, 14, 16, 18];
